import { Box, CircularProgress } from '@mui/material';

export default function OverflowLoader() {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
      }}
    >
      <Box
        sx={(theme) => ({
          position: 'absolute',
          width: 1,
          height: 1,
          backgroundColor: theme.palette.common.white,
          opacity: 0.5,
        })}
      />
      <CircularProgress sx={{ margin: 'auto' }} />
    </Box>
  );
}
